import React from 'react'
import About from './about.jsx';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
// import play from './play';


const Navb = () => {
  return (
    <>
    <Navbar bg="dark" data-bs-theme="dark" style={{opacity:'97%', position: 'fixed', width:'100%' ,top:'0%', overflow:'false'}} >
        <Container>
          <Navbar.Brand href="/"> <img width="10%" src="favicon.ico" alt="[K]" /> Kumpix</Navbar.Brand>
          
          
          
          <Nav >
            <Nav.Link href="/">Home</Nav.Link>
          
            <About/>
            {/* <Nav.Link onClick={()=>play()}>Game</Nav.Link> */}
      
            <Nav.Link href="mailto:sushantmnaik2008@gmail.com">Contact</Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      </>
  )
}

export default Navb;